import apiClient from './api';
import axios from 'axios';
import { ServiceRequest, RequestStatus, PaymentStatus } from '../types/serviceRequest'; // تأكد من وجود هذا النوع
import { PagedResult, TableParams } from '../hooks/useServerSideTable';

export interface ServiceRequestSelectionData {
  id: number;
  fee: number;
  displayText: string;
}

/**
 * جلب قائمة طلبات الخدمات للاختيار
 */
export const getServiceRequestsForSelection = async (): Promise<ServiceRequestSelectionData[]> => {
  const response = await apiClient.get<{ data: ServiceRequestSelectionData[] }>('/service-requests/for-selection');
  return response.data.data;
};
// نوع بيانات التحديث (تغيير الحالة وحالة الدفع)
export interface UpdateServiceRequestData {
  status?: RequestStatus;
  payment_status?: PaymentStatus;
  documents?: any; // إذا أردت السماح بتحديث المستندات
}

// واجهة لبيانات إنشاء طلب خدمة
export interface CreateServiceRequestData {
  service_id: number;
  //user_id: number;
  documents?: { [key: string]: any }; // كائن JSON للمستندات
  fee: number;
}

// واجهة لبيانات إنشاء طلب خدمة (بواسطة المشرف)
export interface CreateAdminServiceRequestData {
  user_id: number; // !! مهم: المشرف يحدد المستخدم !!
  service_id: number;
  fee: number;
  note_text?: string;
  documents?: { name: string; url: string }[];
}



/**
 * دالة لتقديم طلب خدمة جديد
 * @param data - بيانات الطلب
 * @returns الطلب الذي تم إنشاؤه
 */
export const createServiceRequest = async (data: CreateServiceRequestData): Promise<ServiceRequest> => {
  console.log('--- [DEBUG] Using Direct Axios Call ---');
  
  try {
    // (2) !! استخدام axios مباشرة مع كتابة الـ URL كاملاً !!
    const response = await axios.post(
      '/service-requests', // تأكد من أن هذا هو المسار الصحيح
      data,
      {
        headers: {
          // (3 ) !! يجب أن نمرر التوكن يدويًا !!
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json',
        },
      }
    );

    // (4) !! تسجيل كل شيء يعود من الخادم !!
    console.log('✅ [DEBUG] Raw Axios Response:', response);
    console.log('✅ [DEBUG] Response Data:', response.data);

    // (5) !! سنفترض أن البيانات موجودة مباشرة في response.data !!
    return response.data;

  } catch (error: any) {
    // (6) !! تسجيل أي خطأ يحدث !!
    console.error('❌ [DEBUG] Direct Axios Call Failed:', error);
    
    // إعادة إطلاق الخطأ ليتم التقاطه بواسطة toast.promise
    throw error;
  }
};

export const getMyServiceRequests = async (): Promise<ServiceRequest[]> => {
  try {
    // !! استدعاء المسار الجديد !!
    const response = await apiClient.get<{ success: boolean, data: ServiceRequest[] }>('/service-requests/my-requests');
    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch my service requests:", error);
    return [];
  }
};
/**
 * دالة لجلب طلبات الالتحاق بالتدريب المعلقة
 * @returns مصفوفة من طلبات الخدمة
 */
export const getPendingTrainingRequests = async (): Promise<ServiceRequest[]> => {
  // نفترض أن ID خدمة التدريب هو 1
  const response = await apiClient.get<{ data: ServiceRequest[] }>('/service-requests/service/1/pending');
  return response.data.data;
};

/**
 * دالة للموافقة على طلب تدريب
 * @param requestId - معرف طلب الخدمة
 */
export const approveTrainingRequest = async (requestId: number): Promise<void> => {
  await apiClient.patch(`/service-requests/${requestId}/approve-training`);
};
// يمكنك إضافة دوال أخرى هنا مثل جلب طلبات المستخدم، إلخ.
export const getPagedServiceRequests = async (params: TableParams): Promise<PagedResult<ServiceRequest>> => {
  const response = await apiClient.get<{ data: PagedResult<ServiceRequest> }>('/service-requests/paged', { params });
  return response.data.data;
};

/**
 * جلب طلب خدمة بواسطة ID
 */
export const getServiceRequestById = async (id: number): Promise<ServiceRequest> => {
  const response = await apiClient.get<{ data: ServiceRequest }>(`/service-requests/${id}`);
  return response.data.data;
};

/**
 * تحديث طلب خدمة موجود
 */
export const updateServiceRequest = async (id: number, requestData: UpdateServiceRequestData): Promise<ServiceRequest> => {
  const response = await apiClient.put<{ data: ServiceRequest }>(`/service-requests/${id}`, requestData);
  return response.data.data;
};

/**
 * حذف طلب خدمة بواسطة ID
 */
export const deleteServiceRequest = async (id: number): Promise<void> => {
  await apiClient.delete(`/service-requests/${id}`);
};
/**
 * [ADMIN] جلب جميع طلبات الخدمات التي تنتظر المراجعة (PENDING_REVIEW)
 * هذه هي الطلبات التي ستظهر للمشرف لإحالتها إلى بلاغ.
 */
export const getPendingReviewRequests = async (): Promise<ServiceRequest[]> => {
  // نفترض أن لديك نقطة نهاية مخصصة لهذا الغرض
  // GET /service-requests/status/pending_review
  const response = await apiClient.get<{ data: ServiceRequest[] }>('/service-requests/status/pending_review');
  return response.data.data;
};

/**
 * [ADMIN] إحالة مجموعة من الطلبات إلى بلاغ معين
 * @param communiqueId - معرف البلاغ الذي سيتم ربط الطلبات به
 * @param requestIds - مصفوفة من معرفات الطلبات المراد ربطها
 */
export const assignRequestsToCommunique = async (communiqueId: number, requestIds: number[]): Promise<void> => {
  // PUT /communiques/:id/assign-requests
  await apiClient.put(`/communiques/${communiqueId}/assign-requests`, { requestIds });
};

/**
 * [ADMIN] تحديث قرار اللجنة لطلب خدمة معين
 * @param requestId - معرف الطلب المراد تحديثه
 * @param decision - القرار ('approved' أو 'rejected')
 * @param rejection_reason - سبب الرفض (مطلوب في حالة الرفض)
 */
export const updateRequestDecision = async (
  requestId: number, 
  decision: 'approved' | 'rejected', 
  rejection_reason?: string
): Promise<ServiceRequest> => {
  // PUT /requests/:id/update-decision
  const response = await apiClient.put<{ data: ServiceRequest }>(`/requests/${requestId}/update-decision`, {
    decision,
    rejection_reason,
  });
  return response.data.data;
};

